import React from "react";
import { preApprovalSteps } from "./PreApprovalSteps";
import GuidedTour, { BaseTourProps, useGuidedTour } from "../GuidedTour";

const RFX_PREAPPROVAL_TOUR_COOKIE_KEY = "rfx_pre_approval_tour_seen";

export const RfxPreApprovalTour: React.FC<BaseTourProps> = ({
	isVisible = true,
	onTourComplete,
}) => {
	return (
		<GuidedTour
			cookieName={RFX_PREAPPROVAL_TOUR_COOKIE_KEY}
			tourSteps={preApprovalSteps}
			isVisible={isVisible}
			onTourComplete={onTourComplete}
		/>
	);
};

export const useRfxPreApprovalTour = () => {
	return useGuidedTour(RFX_PREAPPROVAL_TOUR_COOKIE_KEY);
};

export default RfxPreApprovalTour;
